import React from 'react';
import cx from 'classnames';
import { Link } from '@zola/zola-ui/src/components/Link';
import {
  CtaEventDataType,
  CtaType,
  trackCtaClicked,
} from '@zola-helpers/client/dist/es/tracking/ctaEvents/ctaEvents';
import TextUtil from 'util/TextUtil';
import { PrimaryNavIdentifier } from '@zola-helpers/client/dist/es/constants/navConstants';
import type { WModuleView } from '@zola/svc-web-api-ts-client';
import { NAV_SECTIONS } from '../../../../util/trackNavigationClickedHelpers';

import { NavMarketingModulesMapStateProps } from './index';
import css from './NavMarketingModules.module.less';

export type NavMarketingModuleProps = NavMarketingModulesMapStateProps & {
  activeNavType: PrimaryNavIdentifier;
  businessUnit?: string;
};

const NavMarketingModules = ({
  marketingModules,
  activeNavType,
  businessUnit,
}: NavMarketingModuleProps): JSX.Element | null => {
  const buildCtaEventData = (index: number): CtaEventDataType => {
    const module = marketingModules[index];
    return {
      business_unit: businessUnit,
      cta_type: CtaType.MARKETING_MODULE,
      group_id: NAV_SECTIONS.primarySubNav,
      cta_id: TextUtil.toAllUpperCase(activeNavType),
      position: index + 1,
      location: NAV_SECTIONS.primarySubNav,
      section: TextUtil.toAllUpperCase(activeNavType),
      cta: module.link_path,
    };
  };

  const handleCtaClick = (i: number) => {
    const eventData = buildCtaEventData(i);
    trackCtaClicked(eventData);
  };

  const className = `${css.container} marketing`;

  const getImageDimensionByModule = (module: WModuleView) => {
    // this vendor marketplace module uses a non-standard image dimension
    if (module.title === 'MEGA_MENU_VENDORS_1_CONTROL') {
      return '184x115';
    }
    return '177x132';
  };

  return marketingModules.length ? (
    <div className={className}>
      {marketingModules.map((module, i) => (
        <Link
          arrow
          inline
          key={i}
          href={module.link_path}
          className={css.module}
          variant="secondary"
          size="smaller"
          onClick={() => handleCtaClick(i)}
        >
          <img
            src={module.images_by_dimension?.[getImageDimensionByModule(module)]}
            alt={module.description}
            className={cx(css.image, css[`image-${module.title}`])}
          />
          <span className={css.label}>{module.link_label}</span>
        </Link>
      ))}
    </div>
  ) : null;
};

export default NavMarketingModules;
